import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackButton from "../Button/BackButton";
import BidCard from "./BidCard";
import useBiddingStore from "./useBiddingStore";
import "./BidsList.css";
import {
  ListPageWrapper,
  ListTopBar,
  ListTopBarLeft,
  ListTopBarTitle,
  ListTopBarSubtitle,
  IconBtn,
  SearchBarWrapper,
  SearchInput,
  FilterRow,
  FilterChip,
  BidCardsWrapper,
} from "./styles.bids";

const STATUS_TITLES = {
  all: "All bids",
  live: "Live bids",
  upcoming: "Upcoming bids",
  awarded: "Awarded bids",
  submitted: "Submitted bids",
  previous: "Previous bids",
};

const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="7" cy="7" r="5" stroke="#293142" strokeWidth="1.5" fill="none"/>
    <path d="M11 11l3 3" stroke="#293142" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const HelpIcon = () => <img src="/logos/bids_help.svg" width="20" height="20" alt="" />;

const BidsList = () => {
  const { status } = useParams();
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { biddingSessions, biddingSessionsStatus, biddingSessionsError, getBiddingSessions } =
    useBiddingStore();

  useEffect(() => {
    getBiddingSessions(status || "live");
  }, [status]);

  const title = STATUS_TITLES[status] || "Bids";

  const filtered = searchQuery
    ? biddingSessions.filter(
        (b) =>
          b.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          b.bidId?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : biddingSessions;

  return (
    <ListPageWrapper>
      <ListTopBar>
        <BackButton />
        <ListTopBarLeft>
          <ListTopBarTitle>{title}</ListTopBarTitle>
          <ListTopBarSubtitle>
            {filtered.length} {status === "live" ? "bids are open" : "bids"}
          </ListTopBarSubtitle>
        </ListTopBarLeft>
        <IconBtn onClick={() => setShowSearch((s) => !s)}>
          <SearchIcon />
        </IconBtn>
        <IconBtn onClick={() => navigate("/bids/faq")}>
          <HelpIcon />
        </IconBtn>
      </ListTopBar>

      {showSearch && (
        <SearchBarWrapper>
          <SearchInput>
            <SearchIcon />
            <input
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by product, bid ID or name"
              className="bids-list-search-input"
            />
          </SearchInput>
        </SearchBarWrapper>
      )}


      <BidCardsWrapper>
        {biddingSessionsStatus === "BEGIN" && (
          <div className="bids-list-state-message">
            Loading bids…
          </div>
        )}

        {biddingSessionsStatus === "FAIL" && (
          <div className="bids-list-state-message bids-list-state-message-error">
            {biddingSessionsError || "Something went wrong. Please try again."}
          </div>
        )}

        {biddingSessionsStatus === "DONE" && filtered.length === 0 && (
          <div className="bids-list-state-message">
            No bids available
          </div>
        )}

        {filtered?.map((bid) => (
          <BidCard
            key={bid.id}
            bid={bid}
            onClick={() =>
              navigate(`/bids/details/${bid.id}`, { state: { bidId: bid.id, status: bid.status || status } })
            }
          />
        ))}
      </BidCardsWrapper>
    </ListPageWrapper>
  );
};

export default BidsList;
